export default {
  path: '/travel-documents/machine-operation',
  name: 'MachineOperation',
  component: () => import(/* webpackChunkName: "base" */ '../views/MachineOperationView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
